import { render, staticRenderFns } from "./currentsAccounts.vue?vue&type=template&id=3c6a32b9&scoped=true&"
import script from "./currentsAccounts.vue?vue&type=script&lang=js&"
export * from "./currentsAccounts.vue?vue&type=script&lang=js&"
import style0 from "./currentsAccounts.vue?vue&type=style&index=0&id=3c6a32b9&prod&lang=css&"
import style1 from "./currentsAccounts.vue?vue&type=style&index=1&id=3c6a32b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6a32b9",
  null
  
)

export default component.exports